import React from 'react';
import { useMessageUnreadCount } from '../hooks/useMessageFeed';

/**
 * Unread count beside the sidebar "Message Feed" entry (BUG 450). Mounted only
 * where that nav item renders, i.e. for users allowed to open the feed, so the
 * poll never runs for a customer.
 */
export default function MessageFeedNavBadge({ dot = false }) {
  const { data: count = 0 } = useMessageUnreadCount();
  if (!count) return null;
  if (dot) {
    return (
      <span
        className="absolute top-1 right-1 h-2 w-2 rounded-full bg-red-600"
        aria-label={`${count} unread`}
      />
    );
  }
  return (
    <span
      className="ml-auto min-w-[1.25rem] rounded-full bg-red-600 px-1.5 text-center text-[11px] font-semibold leading-5 text-white"
      aria-label={`${count} unread`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}
